import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    restrictedTargeting: {
        ".mantine-Text-root": {
            paddingLeft: "0",
            marginLeft: "-2.5rem",
            fontWeight: 400,
            fontSize: ".75rem",
            paddingTop: ".188rem",
        },
        ".mantine-Switch-root": {
            paddingBottom: ".188rem",
        },
        ".mantine-Switch-label": {
            fontSize: ".875rem",
            fontWeight: 400,
        },
    },
    sdgFieldGroup: {
        paddingTop: ".5rem",
        paddingBottom: ".5rem",
        "> span": {
            fontSize: ".875rem",
            fontWeight: 500,
            lineHeight: "1rem",
            paddingBottom: ".25rem",
        },
        ".Select .Select__control": {
            minHeight: "2.5rem",
        },
    },
}))
